import { useEffect, useRef } from 'react';
import { debounce } from 'lodash';

import { validateWaypoints } from '../../../api/services/Rides';
import { useRideEditor } from '../../hooks/useRideEditor';

export const useValidatedWaypoints = (formWaypoints?: WaypointFormType[]) => {
  const { setValidatedWaypoints } = useRideEditor();

  // Track latest request to prevent race conditions
  const requestVersion = useRef(0);

  const debouncedValidate = useRef(
    debounce(async (waypoints) => {
      if (waypoints) {
        const currentRequestVersion = ++requestVersion.current;

        try {
          const response = await validateWaypoints({ waypoints: waypoints });

          // only accept the response if it's the latest
          if (requestVersion.current === currentRequestVersion) {
            setValidatedWaypoints(response?.data?.waypoints || waypoints);
          }
        } catch (error) {
          if (requestVersion.current === currentRequestVersion) {
            setValidatedWaypoints(waypoints);
          }
        }
      }
    }, 200)
  ).current;

  useEffect(() => {
    debouncedValidate(formWaypoints);

    return () => {
      debouncedValidate.cancel();
    };
  }, [formWaypoints]);
};
